/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Fallback_Overage_Budget_ExceededInputs */



/**
* | output |
* | --- |
* | "Overage budget reached. This response used oneAI Standard (free)." |
*
* @param {Chat_Fallback_Overage_Budget_ExceededInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_fallback_overage_budget_exceeded = /** @type {((inputs?: Chat_Fallback_Overage_Budget_ExceededInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Fallback_Overage_Budget_ExceededInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Overage-Budget erreicht. Diese Antwort verwendete oneAI Standard (kostenlos).")
	return /** @type {LocalizedString} */ ("Overage budget reached. This response used oneAI Standard (free).")
});